import React from 'react';
import './styles.css'; // Ensure you have styling for the footer

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2026 NaturoSynth. All rights reserved</p>
      <p>Designed and Developed by Pranav Joshi and Arjun Gopal</p>
    </footer>
  );
};

export default Footer;
